import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./lib/AuthCallback";
import { UserAuthProvider } from "./lib/userAuth";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Google OAuth callback synchronously (URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster richColors position="top-center" closeButton />
      <BrowserRouter>
        <UserAuthProvider>
          <AppRouter />
        </UserAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
